module.exports = __webpack_public_path__ + "img/newchris-92.99b03df8.jpg";